import PrivateRouteComponent from './PrivateRouteComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getIsLoggedIn } from 'actions/auth/login';
import { withRouter } from 'react-router';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

// Create higher-order component which feeds in specified props.
const PrivateRouteContainer = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PrivateRouteComponent)
);

export default PrivateRouteContainer;



// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute/PrivateRouteContainer.js